import Swiper from "swiper";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".icon-card-slider");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");
    if (!slider) return;

    const track = slider.querySelector(".swiper-wrapper");
    const prev = block.querySelector(".swiper-button-prev");
    const next = block.querySelector(".swiper-button-next");
    const paginationEl = block.querySelector(".swiper-pagination");

    if (!track) return;

    // Add swiper-slide to direct icon-card children
    Array.from(track.children).forEach((child) => {
      if (!child.classList.contains("swiper-slide")) {
        child.classList.add("swiper-slide");
      }
    });

    const swiper = new Swiper(slider, {
      spaceBetween: 16,
      slidesPerView: 1,
      loop: false,
      allowTouchMove: true,
      speed: 600,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      modules: [Navigation, Autoplay, Pagination],
    });

    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    }).observe(block);
  });
});
